export default __webpack_public_path__ + "static/no-touch-681f66a6162bdfa2e51988b5593d0159.png";